import React from 'react';
import { Button } from './Button';
import { Save, Download } from 'lucide-react';

interface HeaderControlsProps {
  aspectRatio: string;
  setAspectRatio: (ratio: string) => void;
  onLoadProject?: (project: Record<string, unknown>) => void;
  onLoadAsset?: (asset: Record<string, unknown>) => void;
  currentProjectData?: Record<string, unknown>; // Data to save if "Save Project" is clicked
  minimal?: boolean; // If true, only show icon for save/load
  onExport?: () => void;
  onSave?: () => void;
}

export function HeaderControls({ aspectRatio, setAspectRatio, minimal = false, onExport, onSave }: HeaderControlsProps) {
  return (
    <div className="flex items-center gap-1 sm:gap-2 bg-[rgba(0,0,0,0.98)] backdrop-blur-md border border-white/20 shadow-xl rounded-lg p-0.5 sm:p-1 z-50 text-white">
      {/* Save Button */}
      <Button 
          size="sm" 
          variant="ghost" 
          className="text-[10px] sm:text-xs h-6 sm:h-7 flex items-center gap-1 px-1 sm:px-2"
          onClick={onSave}
          title="Save Stage"
      >
          <Save className="w-2.5 h-2.5 sm:w-3 sm:h-3" />
          {!minimal && <span className="hidden sm:inline">Save</span>}
      </Button>

      {/* Export Button */}
      {onExport && (
          <Button size="sm" variant="ghost" className="text-[10px] sm:text-xs h-6 sm:h-7 flex items-center gap-1 px-1 sm:px-2" onClick={onExport} title="Export Canvas">
              <Download className="w-2.5 h-2.5 sm:w-3 sm:h-3" />
          </Button>
      )}

      <div className="w-px h-3 sm:h-4 bg-black/10 dark:bg-white/10 mx-0.5 sm:mx-1" />

      {/* Aspect Ratio Toggles */}
      <Button size="sm" variant={aspectRatio === '16:9' ? 'secondary' : 'ghost'} onClick={() => setAspectRatio('16:9')} className="text-[10px] sm:text-xs h-6 sm:h-7 w-10 sm:w-12 px-0">16:9</Button>
      <Button size="sm" variant={aspectRatio === '1:1' ? 'secondary' : 'ghost'} onClick={() => setAspectRatio('1:1')} className="text-[10px] sm:text-xs h-6 sm:h-7 w-10 sm:w-12 px-0">1:1</Button>
      <Button size="sm" variant={aspectRatio === '9:16' ? 'secondary' : 'ghost'} onClick={() => setAspectRatio('9:16')} className="text-[10px] sm:text-xs h-6 sm:h-7 w-10 sm:w-12 px-0">9:16</Button>
    </div>
  );
}
